import {Redirect_Admin} from "./shared/utils";

export default {
    items: {
        header: {
            title: true,
            name: 'Baumkontrolle',
            class: ''
        },
        trees: {
            name: 'Bäume',
            url: '/tree',
            icon: 'fa fa-tree fa-md',
            open: true,
            children: [
                {
                    name: 'Baum erfassen',
                    url: '/tree/create',
                },
                {
                    name: 'Alle Bäume',
                    url: '/tree/trees',
                },
                {
                    name: 'Gefällte Bäume',
                    url: '/tree/deleted_trees',
                },
                {
                    name: 'Karte',
                    url: '/tree/map',
                }
            ]
        },
        controls: {
            name: 'Kontrollen',
            url: '/controls',
            icon: 'fa fa-calendar fa-md',
            open: true,
            children: [
                {
                    name: 'Alle Kontrollen',
                    url: '/control/controls',
                },
                {
                    name: 'Kontroll-Touren',
                    url: '/control/tours',
                },
                {
                    name: 'Kontroll-Planung',
                    url: '/control/planning',
                },
                {
                    name: 'Alle Planungen',
                    url: '/control/plannings',
                }
            ]
        },
        tasks: {
            name: 'Maßnahmen',
            url: '/tasks',
            icon: 'fa fa-tasks fa-md',
            open: true,
            children: [
                {
                    name: 'Alle Maßnahmen',
                    url: '/tasks/all',
                },
                {
                    name: 'Maßnahmen Karte',
                    url: '/tasks/map_all',
                },
                {
                    name: 'Maßnahmen Planung',
                    url: '/tasks/planning',
                },
                {
                    name: 'Alle Planungen',
                    url: '/tasks/plannings',
                },
            ]
        },
        tasks_unplanable: {
            name: 'Maßnahmen',
            url: '/tasks',
            icon: 'fa fa-tasks fa-md',
            open: true,
            children: [
                {
                    name: 'Alle Maßnahmen',
                    url: '/tasks/all',
                },
                {
                    name: 'Maßnahmen Karte',
                    url: '/tasks/map_all',
                },
            ]
        },
        tasks_extern: {
            name: 'Maßnahmen',
            url: '/tasks',
            icon: 'fa fa-tasks fa-md',
            open: true,
            children: [
                {
                    name: 'Alle Maßnahmen',
                    url: '/tasks/all',
                },
                {
                    name: 'Maßnahmen Karte',
                    url: '/tasks/map_all',
                },
            ]
        },
        config_admin: {
            name: 'Voreinstellungen',
            url: '/config',
            icon: 'fa fa-wrench fa-md',
            children: [
                {
                    name: 'Kontroll-Schlüssel',
                    url: '/config/data',
                },
                {
                    name: 'Baumarten',
                    url: '/config/schluessel/tree_type',
                },
                {
                    name: 'Vitalität',
                    url: '/config/schluessel/vitality',
                },
                /*{
                    name: 'Maßnahme',
                    url: '/config/schluessel/measure',
                },*/
                {
                    name: 'Maßnahme: Krone',
                    url: '/config/schluessel/measure_top',
                },
                {
                    name: 'Maßnahme: Stamm',
                    url: '/config/schluessel/measure_middle',
                },
                {
                    name: 'Maßnahme: Fuß, Umfeld',
                    url: '/config/schluessel/measure_bottom',
                },
                {
                    name: 'Maßnahme: generell',
                    url: '/config/schluessel/measure_general',
                },
                {
                    name: 'Status: Krone',
                    url: '/config/schluessel/status_top',
                },
                {
                    name: 'Status: Stamm',
                    url: '/config/schluessel/status_middle',
                },
                {
                    name: 'Status: Fuß, Umfeld',
                    url: '/config/schluessel/status_bottom',
                },
                {
                    name: 'Hilfsmittel',
                    url: '/config/schluessel/tools',
                },
                {
                    name: 'Stammaufträge',
                    url: '/config/augr_work',
                },
                {
                    name: 'Baumliste',
                    url: '/config/schluessel/table_option_tree',
                },
                {
                    name: 'Kontrollliste',
                    url: '/config/schluessel/table_option_control',
                },
                {
                    name: 'Maßnahmenliste',
                    url: '/config/schluessel/table_option_task',
                },
                {
                    name: 'Kontrolleure',
                    url: '/config/controller',
                },
                {
                    name: 'Standart Stammauftrag',
                    url: '/config/schluessel_task',
                },
                {
                    name: 'Einstellungen',
                    url: '/config/settings',
                },
                {
                    name: 'Offline Karte',
                    url: '/config/bounds',
                },
                {
                    name: 'Standort-Schlüssel',
                    icon: 'fa fa-map fa-md',
                    children: [
                        {
                            name: 'Kommune',
                            url: '/config/schluessel/commune',
                        },
                        {
                            name: 'Tour',
                            url: '/config/schluessel/tour',
                        },
                        {
                            name: 'Ort',
                            url: '/config/schluessel/city',
                        },
                        {
                            name: 'Ortsteil',
                            url: '/config/schluessel/district',
                        },
                        {
                            name: 'Gebiet',
                            url: '/config/schluessel/area',
                        },
                        {
                            name: 'Objekt-Standort',
                            url: '/config/schluessel/object_location',
                        },
                        {
                            name: 'Stand',
                            url: '/config/schluessel/location',
                        },
                        {
                            name: 'Funktion',
                            url: '/config/schluessel/function',
                        },
                    ]
                },
            ]
        },
        config: {
            name: 'Voreinstellungen',
            url: '/config',
            icon: 'fa fa-wrench fa-md',
            children: [
                {
                    name: 'Maßnahme: Krone',
                    url: '/config/schluessel/measure_top',
                },
                {
                    name: 'Maßnahme: Stamm',
                    url: '/config/schluessel/measure_middle',
                },
                {
                    name: 'Maßnahme: Fuß, Umfeld',
                    url: '/config/schluessel/measure_bottom',
                },
                {
                    name: 'Maßnahme: generell',
                    url: '/config/schluessel/measure_general',
                },
                {
                    name: 'Status: Krone',
                    url: '/config/schluessel/status_top',
                },
                {
                    name: 'Status: Stamm',
                    url: '/config/schluessel/status_middle',
                },
                {
                    name: 'Status: Fuß, Umfeld',
                    url: '/config/schluessel/status_bottom',
                },
                {
                    name: 'Hilfsmittel',
                    url: '/config/schluessel/tools',
                },
                {
                    name: 'Stammaufträge',
                    url: '/config/augr_work',
                }
            ]
        },

        footer: {
            class: 'mt-auto',
            name: 'Administration',
            icon: 'icon-wrench',
            variant: 'secondary',
            url:Redirect_Admin
        },
}
}
